import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ServiceStore } from '../../../../models/service.model';
import { ServiceStoreService } from '../../../../services/service/service-store.service';
import * as moment from 'moment';
import { ServiceService } from '../../../../services/service/service.service';

@Component({
  selector: 'app-store-common-services-form',
  templateUrl: './store-common-services-form.component.html'
})
export class StoreCommonServicesFormComponent implements OnInit {


  form: FormGroup;

  validators = {
    dateStart: KoncentroValidators.checkDateMajorOther('dateEnd'),
    dateEnd: KoncentroValidators.checkDateMinorOther('dateStart')
  }

  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() storeId;

  addEditForm: FormGroup;
  public serviceList: Array<{ value: string, label: string}>;

  fields: any;
  invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private svc: ServiceStoreService,
    private serviceService: ServiceService
  ) { }

  ngOnInit(): void {
    this.serviceList = [];
    this.serviceList.push({ label: 'Select...', value: null });
    this.serviceService.getAll().subscribe(services => {
      for (let service of services) {
        this.serviceList.push({ label: `${service.name}`, value: service.id.toString() });
      }
    });

    this.svc.getFields().subscribe(res => {
      this.fields = res;
    });

    this.form = this.fb.group({
      dateStart: null,
      dateEnd: null,
      serviceId: null
    });


  }

  addService (serviceId, dateStart, dateEnd) {

    if (!this.form.valid) {
     this.invalidSubmit = true;
     return
    }

    let storeService: ServiceStore = new ServiceStore ();
    storeService.serviceId = serviceId;
    storeService.storeId = this.storeId;
    storeService.dateStart =  moment(dateStart.value).format('YYYY-MM-DD').toString();
    storeService.dateEnd =  moment(dateEnd.value).format('YYYY-MM-DD').toString();
    this.svc.post(storeService).subscribe();
    this.onAddElement.emit(storeService);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-services/store-common-services-form.component.ts